import React, { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import FooterThree from "../components/FooterThree";
import NavbarThree from "../components/NavbarThree";
import Content1 from "../components/Content1";

const IndustrialElbow = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      {/* Navigation Bar */}
      <NavbarThree />

      {/* Breadcrumb */}
      <Breadcrumb title={"Industrial Elbow"} />

      {/* Content */}
      <Content1 pageName="Industrial Elbow" />

      {/* Footer */}
      <FooterThree />
    </>
  );
};

export default IndustrialElbow;
